import { render, staticRenderFns } from "./UserText.vue?vue&type=template&id=82262898&scoped=true&"
import script from "./UserText.vue?vue&type=script&lang=js&"
export * from "./UserText.vue?vue&type=script&lang=js&"
import style0 from "./UserText.vue?vue&type=style&index=0&id=82262898&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82262898",
  null
  
)

export default component.exports